export default __webpack_public_path__ + "static/media/2019_2020.81e485a9.png";